var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWxOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.39 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "#fc0a0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.9,94.74a18.26,18.26,0,0,1-16,9.22H18.46a18.44,18.44,0,0,1-16-27.65L41.24,9.22a18.42,18.42,0,0,1,31.92,0L111.9,76.31A18.25,18.25,0,0,1,111.9,94.74ZM62.19,70.05l4.65-43.64v-.06a9.64,9.64,0,0,0-19.28,0v.06L52.2,70.05a5,5,0,0,0,10,0ZM63.7,86.68a6.5,6.5,0,1,0-6.5,6.5A6.51,6.51,0,0,0,63.7,86.68Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxOther);
export default __webpack_public_path__ + "static/media/wxOther.b725dfd5f35fe295531e6b8b39de0cb6.svg";
export { ForwardRef as ReactComponent };